import { FunctionComponent as F, useState, ReactNode, ReactElement, Fragment } from "react";
import CostBreakdownRow from "./CostBreakdownRow";


interface Props
{
  key?: string | number;
  rowGroup: RowGroup;
  rowGroupIndex: number;
}

export interface RowData
{
  item: string,
  value?: number | string,
  show?: boolean,
  tooltip?: ReactNode[],
  bold?: boolean,
  valueColor?: string,
  itemSymbol?: ReactElement,
  valueSymbol?: ReactElement
}

export interface RowGroup extends RowData
{
  rows?: RowData[],
}

const CostBreakdownRowGroup: F<Props> = (props: Props) =>
{
  const rowGroup = props.rowGroup;

  const [open, setOpen] = useState(false);


  return (
    <Fragment key={props.rowGroupIndex}>
      <CostBreakdownRow
        row={rowGroup}
        key={props.rowGroupIndex}
        open={rowGroup.rows ? open : undefined}
        toggleOpen={rowGroup.rows ? () => setOpen(!open) : undefined}
        backgroundColor={'#f9f9f9'}
        fontSize={13}
        bold={rowGroup.bold}/>
      {(rowGroup.rows?.length && open) ? rowGroup.rows
        .filter(subRow => subRow.show || subRow.show === undefined)
        .map((subRow, subRowIndex) =>
          <CostBreakdownRow
            key={props.rowGroupIndex + '-' + subRowIndex}
            row={subRow} />) : <></>}
    </Fragment>);
};

export default CostBreakdownRowGroup;
